import { Skeleton } from '@mui/material';

import { styled } from 'theme';

export const StyledSkeletonMUI = styled(Skeleton)`
  background-color: ${({ theme }) => theme.color.bg.basic};
`;
